import type { RefObject } from "react";
import { useEffect, useState } from "react";

export const useAphFooterOffset = (ref: RefObject<HTMLElement>): string => {
    const [paddingBottom, setPaddingBottom] = useState("0px");

    useEffect(() => {
        if (!ref.current) return () => null;
        const footer = ref.current;
        const updatePaddingBottom = (): void => {
            window.requestAnimationFrame(() => {
                const height = footer.clientHeight;
                const paddingBottomValue = `${height || 0}px`;
                setPaddingBottom(paddingBottomValue);
                document.documentElement.style.setProperty("--padding-bottom-general-footer", paddingBottomValue);
            });
        };
        updatePaddingBottom();

        // Update the value whenever the element's height changes
        const resizeObserver = new ResizeObserver(updatePaddingBottom);
        resizeObserver.observe(footer);

        // Clean up the observer on unmount
        return () => {
            resizeObserver.unobserve(footer);
            resizeObserver.disconnect();
        };
    }, [ref]);

    return paddingBottom;
};
